import { createContext } from 'react';

export const RenderedNavigationContext = createContext<{ disabledRenderedNavigation: boolean } | undefined>(undefined);
